module.exports = __webpack_public_path__ + "img/adminD thumb.dcbc961c.jpg";